
export let uuid = null; 

export function set_uuid(new_uuid) {
    uuid = new_uuid;
}
